<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">培训记录编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="标题" required prop="title">
                                    <el-input v-model="addForm.title"  placeholder="请输入标题"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="状态"  prop="status">
                                    <el-select v-model="addForm.status" placeholder="请选择状态" @change="changeStatus" style="width:100%">
                                        <el-option
                                                v-for="item in status2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="描述" required prop="description">
                                    <el-input v-model="addForm.description" type="textarea" placeholder="请输入描述"></el-input>
                                </el-form-item>
                            </el-col>
                            
                            <el-col :span="24" class="item">
                                <el-form-item label="培训详情" required prop="detail">
                                    <el-upload style="display: none;"
                                            class="avatar-uploader"
                                            action="ddd"
                                            :show-file-list="false"
                                            :before-upload="edit_bf2">
                                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <el-button size="small" type="primary" class="el-btn-edit">点击上传</el-button>
                                    </el-upload>
                                    <div style="line-height:normal;margin:40px 0 20px">
                                        <quill-editor v-model="addForm.detail" ref="myQuillEditor" style="height: 300px;" :options="editorOptionEdit"></quill-editor>
                                    </div>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {getStaffCode} from "@/utils/auth";
    import {hex_md5} from "@/common/Base64MD5";
    const toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        [{'header': 1}, {'header': 2}],               // custom button values
        [{'align': ['']},{'align': ['center']}],
        ['image'],
    ]
    export default {
        name: "Edit",
        data() {
            return {
                loading: false,
                editorOptionEdit: {
                    modules: {
                        toolbar: {
                            container: toolbarOptions,  // 工具栏
                            handlers: {
                                'image': function (value) {
                                    if (value) {
                                        //alert('自定义图片');
                                        document.querySelector('.el-btn-edit').click()
                                    } else {
                                        this.quill.format('image', false);
                                    }
                                }
                            }
                        }
                    }
                },
                imageUrl:"",
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    title:'',
                    description:'',
                    detail:'',
                    trainingRecordCode:'',
                    status:''
                },
                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                rules:{
                    title:[
                        { required: true, message: '请输入标题', trigger: 'blur' },
                    ],
                    description:[
                        { required: true, message: '请输入描述', trigger: 'blur' },
                    ],
                    detail:[
                        { required: true, message: '请输入详情', trigger: 'blur' },
                    ],

                }
            }
        },

        methods: {
            init(row){
                this.addForm.title=row.title;
                this.addForm.description=row.description;
                this.addForm.detail =row.detail;
                this.addForm.status =row.status;
                this.addForm.trainingRecordCode =row.trainingRecordCode;
            },

            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            edit_bf2(file) {

                let fd = new FormData();
                fd.append('file',file);//传文件
                fd.append('staffCode',getStaffCode());//传其他参数
                fd.append('timeStr',timeStr);
                fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));
                let that = this;
                this.$axios.post(this.$institutionUrl+'Upload/Imgs',fd).then(function(res){
                    console.log(res.data);

                    // 获取富文本组件实例
                    let quill = that.$refs.myQuillEditor.quill;

                    // 获取光标所在位置
                    let length = quill.selection.savedRange.index;

                    // 插入图片，res为服务器返回的图片链接地址
                    quill.insertEmbed(length, 'image', that.$imgUrl+res.data.data.path);

                    // 调整光标到最后
                    quill.setSelection(length + 1);

                })

            },
            changeStatus:function (selVal) {
                this.addForm.status = selVal;
            },

            addSubmit(){

                this.loading = true;

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"TrainingRecord/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("init");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }

    }
</script>

<style  lang="scss" scoped>
    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;
    .modal {
        background-color: #fff;
        box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow-x:auto;
        display: flex;
        flex-direction: column;
        border-radius: 10px;
        width: 700px;

    .modal-header {
        border-bottom: 1px solid #eee;
        color: #313131;
        justify-content: space-between;
        padding: 10px;
        display: flex;
    }
    .modal-body {
        position: relative;
        padding: 20px 0px;
        z-index: 99;
        overflow-y: scroll;
        height: 400px;
    }
    .modal-footer {
        border-top: 1px solid #eee;
        justify-content: flex-end;
        padding: 15px;
        display: flex;
    }


    }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }
</style>